import { useState, useEffect } from "react";
import { AxiosError } from "axios";
import { useSearch } from "../search/search-context";
import { getRiskSearchResults } from "./search-results-service";
import { RiskSearchResult } from "./types/risk-search-response";
import { mapRequestDataToSearchParams } from "./use-search-results";
import { useAuth } from "../auth/identity-auth0-context";
import { userErrors, userErrorsMessages } from "../auth/user-errors";

const searchResultsErrorMessage =
  "An error occurred while fetching the results. Please try again later.";

const useSearchResultsData = () => {
  const { hasClientId } = useAuth();
  const form = useSearch();
  const [data, setData] = useState<RiskSearchResult>();
  const [error, setError] = useState<JSX.Element | string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchResults = async () => {
      if (!hasClientId) {
        setError(userErrorsMessages.clientIdNotFound);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        const response = await getRiskSearchResults(
          mapRequestDataToSearchParams(form),
        );

        setData(response);
      } catch (err) {
        setError(searchResultsErrorMessage);

        if (err instanceof AxiosError && err.response) {
          if (err.response.data === userErrors.clientIdNotFound) {
            setError(userErrorsMessages.clientIdNotFound);
          } else if (err.response.data === userErrors.invalidClientId) {
            setError(userErrorsMessages.invalidClientId);
          }
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchResults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return { data, error, isLoading };
};

export default useSearchResultsData;
